/** 设计稿布局常量（iPhone 13 / 390px） */
export const V2_LAYOUT = {
  pageMaxWidth: 390,
  headerHeight: 44,
  statusBarHeight: 48,
  homeIndicatorHeight: 34,
  categoryPaddingX: 16,
  categoryCardWidth: 174,
  categoryCardHeight: 136,
  categoryCardGap: 8,
  categoryIconSize: 84,
  drawerWidth: 272,
  endingButtonHeight: 60,
  endingButtonRadius: 8,
  inputBarHeight: 88,
  inputFieldHeight: 38,
} as const;

export const designMessageBubble = {
  agentBg: "#0E1520",
  userBg: "#0E1520",
  borderRadius: 12,
  maxWidth: 310,
} as const;
